import bs58 from 'bs58';

export enum AccountTypeOld {
  AppCounterparty = 0,
  AppDce = 1,
  AppNft = 2,
  CoinAsset = 3,
  CoinHl = 4,
  CoinMicro = 5,
  ParamCount2 = 15,
  ParamCount8 = 16,
  ProxyMultisig = 21,
  ProxyNftMint = 22,
  ProxyFunding = 23,
  Sys = 24,
  ProxyTokenMint = 25,
  AppStackable = 90,
  GtNwa = 91,
  ParamBoolean = 92,
  ProxyDce = 93,
}
export enum AccountType {
  AppCounterparty = 1,
  AppDce = 2,
  AppNft = 3,
  AppStackable = 4,
  CoinAsset = 5,
  CoinHl = 6,
  CoinMicro = 7,
  GtNwa = 8,
  ParamBoolean = 9,
  ParamCount2 = 10,
  ParamCount8 = 11,
  ProxyDce = 12,
  ProxyFunding = 13,
  ProxyMultisig = 14,
  ProxyNftMint = 15,
  ProxyTokenMint = 16,
  Sys = 17,
}
export function decodeBase58ToByteArray(base58String: string) {
  return bs58.decode(base58String);
}

export function getAccountTypeFromBase58String(base58String: string): AccountType | null {
  // return AccountType.CoinAsset;
  try {
    console.log('base58String', base58String);
    const buffer = bs58.decode(base58String);

    if (buffer.length < 5) {
      return null;
    }
    
    const value = buffer[4]; // Get the 5th symbol's value (0-based index)

    switch (value) {
      case AccountType.ProxyNftMint:
        return AccountType.ProxyNftMint;
      case AccountType.ProxyMultisig:
        return AccountType.ProxyMultisig;
      case AccountType.ProxyFunding:
        return AccountType.ProxyFunding;
      case AccountType.ProxyTokenMint:
        return AccountType.ProxyTokenMint;
      case AccountType.CoinAsset:
        return AccountType.CoinAsset;
      default:
        return null;
    }
  } catch (error) {
    console.error('Invalid Base58 string:', error);
    return null;
  }
}
